import SelectControl from './component'

export default SelectControl
